exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.step[data-v-2fc5bd2e] {\n  position: absolute;\n  color: #3d065f;\n  font-size: 14px;\n  line-height: 18px;\n  font-weight: bold;\n  z-index: 2;\n  text-align: center;\n}\n.step span[data-v-2fc5bd2e] {\n  font-size: 18px;\n}\n.step .insideimg[data-v-2fc5bd2e] {\n  width: 50%;\n}\n", ""]);

// exports
